import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/liquidation/:id',
    component: () => import('@/components/Client/Liquidation/Liquidation.vue'),
    name: 'liquidation',
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
        dossier: 'client',
    },
} as RouteRecordRaw;
